module.exports = __webpack_public_path__ + "static/media/4.3faf4195.png";